var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterpur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 4.52869C36.61 5.13846 35.1288 5.54264 33.5845 5.73889C35.1732 4.79035 36.3857 3.29979 36.9558 1.50316C35.4745 2.38629 33.8391 3.01008 32.0962 3.35819C30.6898 1.86062 28.6852 0.933105 26.4984 0.933105C22.2557 0.933105 18.84 4.37683 18.84 8.59854C18.84 9.20598 18.8914 9.79005 19.0176 10.3461C12.6465 10.0354 7.00895 6.98181 3.22179 2.33022C2.56061 3.47735 2.17279 4.79035 2.17279 6.20382C2.17279 8.85787 3.53953 11.2105 5.57679 12.5726C4.34555 12.5492 3.13768 12.1918 2.11438 11.6287C2.11438 11.6521 2.11438 11.6825 2.11438 11.7128C2.11438 15.4369 4.77076 18.5302 8.2542 19.2428C7.6304 19.4133 6.95054 19.4951 6.24497 19.4951C5.75435 19.4951 5.25905 19.467 4.79413 19.3643C5.78706 22.3991 8.60465 24.6303 11.9549 24.7027C9.34759 26.7423 6.03704 27.9712 2.45314 27.9712C1.82468 27.9712 1.22191 27.9432 0.619141 27.8661C4.0138 30.0552 8.03692 31.3051 12.3754 31.3051C26.4774 31.3051 34.1872 19.6236 34.1872 9.49802C34.1872 9.15925 34.1756 8.83217 34.1592 8.50742C35.6801 7.42805 36.9581 6.08 38.0001 4.52869Z",
    fill: "#6020BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterpur);
export default __webpack_public_path__ + "static/media/twitterpur.1e76fa58c27527c72b10478a31ea8c1c.svg";
export { ForwardRef as ReactComponent };